import { Component, inject, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MessageDialogComponent } from '../../dialog/message-dialog/message-dialog.component';
import { MatButton } from "@angular/material/button";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { FakeCaptchaComponent } from "./fake-captcha/fake-captcha.component";

@Component({
  selector: 'app-your-data',
  imports: [MatButton, MatFormField, MatLabel, MatInput, FakeCaptchaComponent, FormsModule],
  templateUrl: './your-data.component.html',
  styleUrl: './your-data.component.less'
})
export class YourDataComponent {
  readonly dialog = inject(MatDialog);
  @ViewChild(FakeCaptchaComponent) captcha!: FakeCaptchaComponent;
  downloadEnabled = false;
  username = '';
  correctUsername = '';
  isRigged = false;

  onCaptchaSuccess(type: 'magic' | 'random' | void) {
    this.downloadEnabled = true;

    if (type === 'random' && this.username && this.username.length >= 2) {
      this.isRigged = true;
      this.correctUsername = this.username;
      
      // Swap two characters
      const chars = this.username.split('');
      const idx1 = Math.floor(Math.random() * (chars.length - 1));
      const idx2 = idx1 + 1;
      
      const temp = chars[idx1];
      chars[idx1] = chars[idx2];
      chars[idx2] = temp;
      
      this.username = chars.join('');
    }
  }

  onDownload() {
    if (!this.isRigged) {
        this.openDialog('Download', 'Download started!');
        return;
    }

    if (this.username === this.correctUsername) {
        this.openDialog('Error', 'Your link has expired. Please get in touch with the support team to get a new link.');
    } else {
        this.openDialog('Error', 'Your username is incorrect! Please make sure to spell your username correctly to verify your identity.');
    }
    
    this.captcha.reset();
    this.downloadEnabled = false;
  }

  openDialog(title: string, message: string) {
    this.dialog.open(MessageDialogComponent, {
      data: { title, message }
    });
  }
}
